  // Set a timeout to delay the entire operation
setTimeout(() => {
  // Select all file input fields inside .checkbox_result divs
  const fileInputs = document.querySelectorAll('.checkbox_result input[type="file"]');

  // Loop through each input field and add a change event listener
  fileInputs.forEach(function(input) {
    input.addEventListener('change', function() {
      // Get the file name or fallback text if no file is selected
      const fileName = this.files[0] ? this.files[0].name : "No file chosen";
      
      // Find the <p> tag inside the closest .checkbox_result div and update its content
      const fileNameElement = this.closest('.checkbox_result').querySelector('p');
      fileNameElement.textContent = fileName;
    });
  });


  // Handle the custom file uploader
  const uploaderContainer = document.querySelector('.custom_file_uploader');
  if (uploaderContainer) {
    let fileNameElement = uploaderContainer.querySelector('.file-name');
    if (!fileNameElement) {
      fileNameElement = document.createElement('p');
      fileNameElement.className = 'file-name';
      fileNameElement.textContent = 'No file selected';
      uploaderContainer.appendChild(fileNameElement);
    }

    const fileInput = document.getElementById('ctm_mosa_kit--file');
    if (fileInput) {
      fileInput.addEventListener('change', function(event) {
        const fileName = this.files[0] ? this.files[0].name : 'No file selected';
        fileNameElement.textContent = fileName;
      });
    }
  }
}, 3000);
